import { useTranslation } from "@coworker/locales";
import {
  FilterType,
  FilterValue,
  InputType,
  MultiSelectFilter,
  StringFilterValue,
} from "../../shared/filters/types/filter";
import { TASK_TYPE_ID } from "./useTaskTypeFilter";
import { useLocationsOptions } from "./useLocationsOptions";
import { useActivityLocations } from "./useActivityLocations";

const PICKUP_LOCATIONS_ID = "pickupLocations";

export function usePickupLocationsFilter(
  filterValues: FilterValue[]
): MultiSelectFilter {
  const { t } = useTranslation();
  const defaultValue = {
    filterId: PICKUP_LOCATIONS_ID,
    value: [],
  };

  const taskTypeValue = filterValues.find(
    ({ filterId }) => filterId === TASK_TYPE_ID
  );
  const taskTypeValueValue = (taskTypeValue as StringFilterValue)?.value ?? "";
  const isPickupLocationsAvailable =
    taskTypeValueValue === "refill" || taskTypeValueValue === "pickAndRefill";

  const enabled = isPickupLocationsAvailable;
  const { data: taskLocations, isFetching } = useActivityLocations(
    taskTypeValueValue,
    "pickup",
    enabled
  );
  const options = useLocationsOptions(taskTypeValueValue, taskLocations ?? []);

  return {
    inputType: InputType.MultiSelect,
    filterType: FilterType.Filter,
    id: PICKUP_LOCATIONS_ID,
    title: t("pickupLocation"),
    options,
    enabled,
    defaultValue,
    showSearch: true,
    noResultsTitle: t("noLocationsString"),
    noResultsDescription: t("noLocationsAvailableTaskTypeString"),
    isFetching,
  };
}
